import { render, staticRenderFns } from "./ContactUsList.vue?vue&type=template&id=5e3cfb0c&scoped=true&"
import script from "./ContactUsList.vue?vue&type=script&lang=js&"
export * from "./ContactUsList.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsList.vue?vue&type=style&index=0&id=5e3cfb0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3cfb0c",
  null
  
)

export default component.exports